import React from 'react';
import { Check, Minus } from 'lucide-react';
const features = [{
  name: '6 tomos',
  base: true,
  premium: true
}, {
  name: '6 bonos',
  base: true,
  premium: true
}, {
  name: 'Acceso inmediato',
  base: true,
  premium: true
}, {
  name: 'Material digital',
  base: true,
  premium: true
}, {
  name: 'Contenido extra exclusivo',
  base: false,
  premium: true
}, {
  name: 'Mayor profundidad',
  base: false,
  premium: true
}, {
  name: 'Mejor valor total',
  base: false,
  premium: true
}, {
  name: 'Opción recomendada',
  base: false,
  premium: true
}];
export function ComparisonTable() {
  return <section className="py-6 bg-transparent" data-id="element-36">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-37">
        <div className="glass-card rounded-3xl overflow-hidden border border-white/10" data-id="element-38">
          <div className="grid grid-cols-3 bg-[#161616] border-b border-white/10" data-id="element-39">
            <div className="p-6" data-id="element-40"></div>
            <div className="p-6 text-center font-bold text-gray-400" data-id="element-41">
              Oferta Base
            </div>
            <div className="p-6 text-center font-bold text-orange-400 bg-orange-500/5" data-id="element-42">
              Oferta Premium
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-43">
            {features.map((feature, i) => <div key={i} className="grid grid-cols-3 hover:bg-white/[0.02] transition-colors" data-id="element-44">
                <div className="p-4 md:p-6 text-sm md:text-base text-gray-300 font-medium flex items-center" data-id="element-45">
                  {feature.name}
                </div>
                <div className="p-4 md:p-6 flex items-center justify-center" data-id="element-46">
                  {feature.base ? <Check className="w-5 h-5 text-gray-500" data-id="element-47" /> : <Minus className="w-5 h-5 text-gray-700" data-id="element-48" />}
                </div>
                <div className="p-4 md:p-6 flex items-center justify-center bg-orange-500/5" data-id="element-49">
                  {feature.premium ? <Check className="w-6 h-6 text-orange-500" data-id="element-50" /> : <Minus className="w-5 h-5 text-gray-700" data-id="element-51" />}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}